<bit-callout title="{{ 'prerequisite' | i18n }}">
  {{ "requireSsoPolicyReq" | i18n }}
</bit-callout>

<bit-form-control>
  <input type="checkbox" bitCheckbox [formControl]="enabled" id="enabled" />
  <bit-label>{{ "turnOn" | i18n }}</bit-label>
</bit-form-control>

<div [formGroup]="data">
  <bit-form-field class="tw-flex-auto bv-mat-field tw-w-full">
    <bit-label>{{ "uriMatchDetectionOptionsLabel" | i18n }}</bit-label>
    <bit-select formControlName="uriMatchDetection" id="uriMatchDetection">
      <bit-option
        *ngFor="let o of uriMatchOptions"
        [label]="o.label"
        [value]="o.value"
        [disabled]="o.disabled"
      ></bit-option>
    </bit-select>
  </bit-form-field>
</div>
